import React from 'react'
import Icon from 'app/views/components/Icon'


class ModalListItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
        
    }
    render() {
        let points = parseInt(this.props.points) || 0
        return (
            <div
                style={{
                    cursor: 'pointer',
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    color: (this.props.used ? '#BDBDBD' : ''),
                    background: (this.props.used ? '#F6F6F7' : ''),
                    borderRadius: '15px'
                }}
                onClick={this.props.onClick ? this.props.onClick : ''}
            >
                <div style={{
                    alignSelf: "flex-start"
                }}>
                    <Icon
                        name={this.props.type == 'basic' ? 'question' : (this.props.type == 'highlight' ? 'terminal' : (this.props.type == 'contact-support' ? 'chat-3' : (this.props.type == 'help-articles' ? 'lifebuoy' : 'question')))}
                        className="uk-margin-small-right"
                        style={{
                            color: this.props.used ? '#BDBDBD' : '#1e87f0'
                        }}
                    />
                </div>
                <div style={{ flexGrow: 1 }}>
                    <div>
                        <label style={{cursor: 'pointer'}}>{this.props.title}</label>
                        {(points != 0) &&
                    
                            <span
                                className="uk-label"
                                style={{
                                    marginLeft: '20px',
                                    borderRadius: '10px',
                                    background: (this.props.used ? '#BDBDBD' : '')
                                }}>
                                {!this.props.used ? `${points} points` : 'Used'}
                            </span>}
                    </div>
                    <span>{this.props.description}</span>
                </div>
                <div>
                    <Icon
                        style={{ color: "#BDBDBD" }}
                        name="arrow-right-s"
                        className="uk-margin-small-right"
                    />
                </div>
            </div>)
    }
}
export default ModalListItem
